<template>
  <div class="main-wrapper">
    <div>
      <!-- <layout-header3></layout-header3> -->
      <layout-header></layout-header>
      <template>
    <!-- Breadcrumb -->
    <div class="breadcrumb-bar" style="background-color: #3CB371;">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-md-12 col-12">
                    <nav aria-label="breadcrumb" class="page-breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
                            <li class="breadcrumb-item active" aria-current="page">Profile</li>
                        </ol>
                    </nav>
                    <h2 class="breadcrumb-title">Profile of {{ patient_profile.first_name }} {{ patient_profile.last_name }}</h2>
                </div>
            </div>
        </div>
    </div>
    <!-- /Breadcrumb -->
</template>
      <!-- Page Content -->
      <div class="content">
        <div class="container">
          <div class="row">
            <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
              <sidebar1></sidebar1>
            </div>

            <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
              <loader></loader>
            </div>
            <div class="col-md-7 col-lg-8 col-xl-9 doctor-profile" v-else>
              <div class="card ml-md-4">
                <div class="card-body">
                  <!-- Profile Settings Form -->
                  <form @submit.prevent="Save_Information">
                    <div class="row form-row">
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <label>First Name</label>
                          <input type="text" readonly v-model="patient_profile.first_name" class="form-control"
                            placeholder="First Name" />
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <label>Middle Name</label>
                          <input type="text" v-model="patient_profile.middle_name" class="form-control"
                            placeholder="Middle Name" oninput="this.value = this.value.replace(/[^a-zA-Z ]/g, ''); 
                                    if (this.value.startsWith(' ')) this.value = this.value.trim();" />
                        </div>
                      </div>



                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <label>Last Name</label>
                          <input type="text" readonly v-model="patient_profile.last_name" class="form-control"
                            placeholder="Last Name" />
                        </div>
                      </div>

                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <label>Father/Husband Name</label>
                          <input type="text" v-model="patient_profile.custom_father_name" class="form-control"
                            placeholder="Father/Husband Name" oninput="this.value = this.value.replace(/[^a-zA-Z ]/g, ''); 
                                    if (this.value.startsWith(' ')) this.value = this.value.trim();" />
                        </div>
                      </div>

                      <div class="col-12 col-md-6">

                        <div class="form-group">
                          <label>Date of Birth
                           
                          </label>
                          <datepicker input-class="datepicker-here form-control digits" :format="formats"
                            v-model="patient_profile.dob" :disabled="isDateOfBirthAvailable" :required="true"
                            @input="changedDate()"></datepicker>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                              <label>WhatsApp Number</label>
                              <div class="input-group">
                                <div class="input-group-prepend">
                                  <span class="input-group-text">91</span>
                                </div>
                                <input type="text" :value="formattedMobileNo" class="form-control" disabled required />
                              </div>
                            </div>
                        <!-- <div class="form-group">
                          <label>Mobile No</label>
                          <input type="text" readonly v-model="patient_profile.mobile" class="form-control"
                            placeholder="Mobile No" oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                            minlength="10" maxlength="10" />
                        </div> -->
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                              <label>Alternate Number</label>
                              <div class="input-group">
                                <div class="input-group-prepend">
                                  <span class="input-group-text">91</span>
                                </div>
                                <input type="text" v-model="patient_profile.whatsapp_no" class="form-control"
                                  maxlength="10" minlength="10"
                                  oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                              </div>
                            </div>
                        <!-- <div class="form-group">
                          <label>Whatsapp No</label>
                          <input type="text" maxlength="10" minlength="10" v-model="patient_profile.whatsapp_no"
                            class="form-control" placeholder="Whatsapp No"
                            oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                        </div> -->
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <label>Aadhar No. </label><span class="text-danger">*</span>
                          <input type="text" minlength="12" maxlength="12" v-model="patient_profile.aadhar_no"
                            class="form-control" required="true"
                            
                            oninput="this.value = this.value.replace(/[^0-9]/g, '');" placeholder="Aadhar No" />
                        </div>
                      </div>

                      <!-- <div class="col-12 col-md-6">
                        <div class="form-group">
                          <label>Aadhar No</label>
                          <input
                            type="text"
                            minlength="12"
                            maxlength="12"
                            v-model="patient_profile.aadhar_no"
                            class="form-control"
                            placeholder="Aadhar No"
                          />
                        </div>
                      </div> -->
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <label>Blood Group</label>
                          <v-select class="mr-2" name="name" required="" placeholder="select blood group"
                            v-model="patient_profile.blood_group" :options="blood_groups">
                          </v-select>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <label>Gender</label>
                          <v-select class="mr-2" name="gender" required="" label="gender" placeholder="select gender"
                            v-model="patient_profile.sex" :reduce="(option) => option.gender" :options="genders">
                          </v-select>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <label>Marital Status</label>
                          <v-select class="mr-2" required="" placeholder="select marital status"
                            v-model="patient_profile.marital_status" :options="marital_status">
                          </v-select>
                        </div>
                      </div>

                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <label>State</label>
                          <v-select class="mr-2" name="state" required="" label="state" placeholder="select state"
                            v-model="patient_profile.state" :reduce="(option) => option.state" @input="
                              get_cities();
                            patient_profile.city = '';
                            " :options="states">
                          </v-select>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <label>City</label>
                          <v-select class="mr-2" name="city" required="" label="city" placeholder="select city"
                            v-model="patient_profile.city" :reduce="(option) => option.city" :options="cities">
                          </v-select>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-12 text-left">
                    <div class="submit-section" style="margin-left: -15px;">
                      <button type="submit" class="btn btn-primary submit-btn text-left">
                        Save Changes
                      </button>
                    </div>
                    </div>
                  </form>
                  <!-- /Profile Settings Form -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Content -->
      <layout-footer></layout-footer>
    </div>
  </div>
</template>

<script>
import config from "../../../services/CommonApi";
import CommonApi from "../../../services/CommonApi";
import Datepicker from "vuejs-datepicker";
import { mapState } from "vuex";
const images = require.context("@/assets/img/patients");
export default {
  data() {
    return {
      formats: "dd-MM-yyyy",
      state: {
        disabledDates: {
          from: new Date(),
        },
      },
      user_image: localStorage.getItem("userInfo")
        ? JSON.parse(localStorage.getItem("userInfo")).image
        : null,
      config: config,
      patient_profile: {
        name: this.$store.state.user.user_id,
        first_name: "",
        middle_name: "",
        last_name: "",
        custom_father_name: "",
        dob: "",
        mobile: "",
        whatsapp_no: "",
        aadhar_no: "",
        blood_group: "",
        sex: "",
        marital_status: "",
        state: "",
        city: "",
      },
      blood_groups: [],
      genders: [],
      marital_status: [],
      states: [],
      cities: [],
      showspinner: true,
    };
  },
  components: { Datepicker },
  computed: {
    formattedMobileNo() {
      return this.patient_profile.mobile ? this.patient_profile.mobile.slice(-10) : '';
    },

    isDateOfBirthAvailable() {
      return !!this.patient_profile.dob;
    },
    format() {
      // Define your date format here
      return "yyyy-MM-dd";
    },
    ...mapState({
      user_id: (state) => state.user.user_id,
    }),
  },
  mounted() {
    let user = localStorage.getItem("userInfo");
    if(!user){
      this.$router.push({name:'login'})
    }
    this.get_patient_profile();
    this.get_blood_group();
    this.get_gender();
    this.get_marital_status();
    this.get_states();
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%",
      });
    }
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fas fa-chevron-up",
          down: "fas fa-chevron-down",
          next: "fas fa-chevron-right",
          previous: "fas fa-chevron-left",
        },
      });
    }
  },
  methods: {
    /* Get Updated date */
    changedDate() {
      this.patient_profile.dob = this.patient_profile.dob
        .toISOString()
        .split("T")[0];
    },

    /* Get Blood Groups */
    async get_blood_group() {
      await CommonApi.get_data("sahaj.api.get_blood_group").then((res) => {
        this.blood_groups = res.message;
      });
    },

    /* Get Profile Image */
    loadImg(imgPath) {
      return images("./" + imgPath);
    },

    /* Change Profile Image */
    onFileChange(e) {
      var files = e.target.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },

    /* Create Profile Image */
    createImage(file) {
      var reader = new FileReader();
      reader.onload = (e) => {
        this.update_patient_profile(file.name, e.target.result);
      };
      reader.readAsDataURL(file);
    },

    /* Upload Image API */
    async update_patient_profile(filename, upload_image) {
      this.$swal({
        text: "Updating Profile Photo...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      let data = {
        patient: this.$store.state.user.user_id,
        filename: filename,
        decode_base64: 1,
        filedata: upload_image,
      };
      await CommonApi.post_data(
        "sahaj.document.profile_photo_upload",
        JSON.stringify(data)
      ).then((res) => {
        if (res && res.status_code == 200) {
          const retrievedString = localStorage.getItem("userInfo");
          const parsedObject = JSON.parse(retrievedString);
          parsedObject.image = res.data;
          const strigifiedForStorage = JSON.stringify(parsedObject);
          localStorage.setItem("userInfo", strigifiedForStorage);
          this.$swal.fire({
            icon: "success",
            title: "Success",
            text: res.message,
            showConfirmButton: true,
            }).then(() => {
              window.location.reload();
            });
        }
      });
    },

    /* Get Genders */
    async get_gender() {
      await CommonApi.get_data("sahaj.api.get_gender").then((res) => {
        this.genders = res.data;
      });
    },

    /* Get Marital Status */
    async get_marital_status() {
      await CommonApi.get_data("sahaj.api.get_marital_status").then((res) => {
        this.marital_status = res.message;
      });
    },

    /* Get States */
    async get_states() {
      await CommonApi.get_data("sahaj.finalapi.get_states").then((res) => {
        this.states = res.message;
      });
    },

    /* Get Cities */
    async get_cities() {
      // this.patient_profile.city = "";
      const params = new URLSearchParams();
      params.append("state", this.patient_profile.state);
      await CommonApi.get_data("sahaj.finalapi.get_city", params).then(
        (res) => {
          this.cities = res.message;
        }
      );
    },

    /* Get Patient Profile */
    async get_patient_profile() {
      const params = new URLSearchParams();
      params.append("name", this.user_id);
      await CommonApi.get_data(
        "sahaj.finalapi.get_patient_profile",
        params
      ).then((res) => {
        this.showspinner = false;
        if (res && res.data && res.status_code === 200) {
          this.patient_profile.first_name = res.data.first_name;
          this.patient_profile.middle_name = res.data.middle_name;
          this.patient_profile.last_name = res.data.last_name;
          this.patient_profile.custom_father_name = res.data.custom_father_name;
          this.patient_profile.dob = res.data.dob;

          this.patient_profile.mobile = res.data.mobile;
          this.patient_profile.whatsapp_no = res.data.whatsapp_no;
          this.patient_profile.aadhar_no = res.data.aadhar_no;

          this.patient_profile.blood_group = res.data.blood_group;
          this.patient_profile.sex = res.data.sex;
          this.patient_profile.marital_status = res.data.marital_status;
          this.patient_profile.state = res.data.state;
          this.patient_profile.city = res.data.city;
          this.get_cities();
        }
      });
    },

    /* Save Patient Profile */
    Save_Information() {
      // if (!this.patient_profile.dob) {
      //   this.$swal.fire({
      //     icon: "warning",
      //     title: "Warning",
      //     text: "Please select your date of birth from About Me tab.",
      //     showConfirmButton: true,
      //   });
      //   return; // Stop further execution
      // }

      this.$swal({
        text: "Updating Profile Changes...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      var data = new FormData();
      delete this.patient_profile.state;
      data.append("patient_profile", JSON.stringify(this.patient_profile));
      CommonApi.post_data("sahaj.api.update_patient_profile", data).then(
        (res) => {
          if (res && res.status_code === 200) {
            console.log(res)
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              showConfirmButton: true,
            }).then(() => {
              window.location.reload();
            });
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: res.message,
              showConfirmButton: true,
            });
          }
        }
      );
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/kneexpert/patient/Profile.vue